import { ReservationOptions, ReservationTimeState, ServiceOrderState } from '@mews-commander/data-access';
import { CompanionAccommodationExtent, TextKey } from '@mews-commander/enums';
import { isHoldingState } from '@mews-commander/types';
import { isOnlineCheckedIn } from './isOnlineCheckedIn';
import { isOnlineCheckedOut } from './isOnlineCheckedOut';

const enumToTextKeyMap = {
    [ServiceOrderState.Canceled]: TextKey.ServiceOrderStateCanceled,
    [ServiceOrderState.Inquired]: TextKey.ServiceOrderStateInquired,
    [ServiceOrderState.Requested]: TextKey.ServiceOrderStateRequested,
    [ReservationTimeState.CheckInMissed]: TextKey.ReservationTimeStateCheckInMissed,
    [ReservationTimeState.CheckOutMissed]: TextKey.ReservationTimeStateCheckOutMissed,
    [ReservationTimeState.CheckedIn]: TextKey.CheckedIn,
    [ReservationTimeState.ConfirmationMissed]: TextKey.ConfirmationMissed,
    [ReservationTimeState.Future]: TextKey.ReservationTimeStateFuture,
    [ReservationTimeState.Past]: TextKey.ReservationTimeStatePast,
    [ReservationTimeState.ToBeCheckedIn]: TextKey.ReservationTimeStateToBeCheckedIn,
    [ReservationTimeState.ToBeCheckedOut]: TextKey.ReservationTimeStateToBeCheckedOut,
    [ReservationTimeState.ToBeConfirmed]: TextKey.ToBeConfirmed,
} as const;

const getTextKeyOrNullFromServiceOrderStateEnum = (
    enumValue: ReservationTimeState | ServiceOrderState,
    companionExtent: CompanionAccommodationExtent,
    options: ReservationOptions
) => {
    switch (enumValue) {
        case ReservationTimeState.ToBeCheckedOut:
            return isOnlineCheckedOut(options) ? TextKey.OnlineCheckedOut : null;
        case ReservationTimeState.ToBeCheckedIn:
            return isOnlineCheckedIn(companionExtent, options) ? TextKey.OnlineCheckedIn : null;
        default:
            return null;
    }
};

export const getTextKeyFromServiceOrderState = (
    state: ServiceOrderState,
    timeState: ReservationTimeState,
    companionExtent: CompanionAccommodationExtent,
    options: ReservationOptions
) => {
    const finalStateEnum = isHoldingState(state) ? timeState : state;
    const textKey = getTextKeyOrNullFromServiceOrderStateEnum(finalStateEnum, companionExtent, options);
    return textKey || enumToTextKeyMap[finalStateEnum];
};
